require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./front-end-libraries-bootstrap-create-a-custom-heading.json") })
        }
      }, "path---front-end-libraries-bootstrap-create-a-custom-heading");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---front-end-libraries-bootstrap-create-a-custom-heading!./.cache/json/front-end-libraries-bootstrap-create-a-custom-heading.json
// module id = 2007
// module chunks = 231608221292675